module.exports = __webpack_public_path__ + "static/media/SoLogo.d7948dfb.png";